module.exports = __webpack_public_path__ + "static/media/55.4bcb140b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/55.jpg
// module id = 998
// module chunks = 0